export default "__VITE_ASSET__$GStT99X__"